import { getCompanyTypeLabel } from "../../../../../components/filters/CompanyType/components/utils";
import { CompanyFilter } from "../../../../../legacy/types/companyFilter";

export const useCompanyTypeLabel = (filter?: CompanyFilter) => {
  if (!filter) return "";

  const { isGhq = false, isGp = false, isDp = false } = filter;

  return getCompanyTypeLabel({ isGhq, isGp, isDp });
};
